import React from "react";
import { Typography } from "components";
import { FaExchangeAlt } from "react-icons/fa";

const ResetFilterCta = ({ onClick }) => {
  return (
    <div className="cursor-pointer" onClick={onClick}>
      <Typography state="grey" variant="body3" component="span">
        Reset Filter
      </Typography>{" "}
      <FaExchangeAlt
        style={{
          color: "grey",
          fontSize: "14px",
          marginLeft: ".3rem",
        }}
      />
    </div>
  );
};

export default ResetFilterCta;
